module.exports = __webpack_public_path__ + "static/media/ic-grid.e0111469.svg";